export enum Transport {
  Air = 'air',
  Sea = 'sea',
}
